import { render } from "./MMenuItem.vue?vue&type=template&id=acf39cb0&scoped=true"
import script from "./MMenuItem.vue?vue&type=script&lang=js"
export * from "./MMenuItem.vue?vue&type=script&lang=js"

import "./MMenuItem.vue?vue&type=style&index=0&id=acf39cb0&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf39cb0"]])

export default __exports__